import { useMutation } from '@tanstack/react-query';

import { RedBookData } from '../../../../types/redbook';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postSaveRedBookData } from '../../requests/postSaveRedBookData';

export const useSaveRedBookData = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: RedBookData) => postSaveRedBookData(constructPost, data),
    onSuccess: () => handleSuccess('Redbook valuation saved'),
    onError: () => handleError('Could not save Redbook valuation.'),
  });
  return { saveRedBookData: mutateAsync, ...rest };
};
